module.exports = __webpack_public_path__ + "media/images/checkout/challenger/search-9f8838759b2fe08b1673d22d887d6782.svg";